<template>
  <div class="myDocuments">
    <Header />
    <div uk-height-viewport>
      <legend
        class="uk-legend uk-margin-left uk-margin-bottom uk-text-left uk-text-bold"
      >Mes documents</legend>

      <div class="uk-flex uk-flex-center uk-overflow-auto">
        <table
          class="uk-table uk-table-middle uk-table-large uk-table-divider uk-table-hover"
          id="quotationsTable"
          data-order='[[ 1, "asc" ]]'
          data-page-length="25"
          v-show="documents.length > 0"
        >
          <thead>
            <tr>
              <th class="uk-text-center">
                <p class="uk-text-bold">Date</p>
              </th>
              <th class="uk-text-center">
                <p class="uk-text-bold">Type</p>
              </th>
              <th class="uk-text-center">
                <p class="uk-text-bold">Identifiant</p>
              </th>
              <th class="uk-text-center">
                <p class="uk-text-bold">Montant</p>
              </th>
              <th class="uk-text-center">
                <p class="uk-text-bold">Statut</p>
              </th>
              <th class="uk-text-center uk-width-1-6">
                <p class="uk-text-bold"></p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(document, index) in documents" :key="index">
              <td class="uk-text-middle">{{toNumericReadableFormat(document.createdAt.toDate())}}</td>
              <td class="uk-text-middle">{{getReadableType(document)}}</td>
              <td class="uk-text-middle">#{{document.ID()}}</td>
              <td class="uk-text-middle">{{document.amount.toFixed(2)}}€</td>
              <td class="uk-text-middle">{{getReadableStatus(document)}}</td>
              <td class="uk-text-middle uk-inline">
                <button
                  v-on:click="consult(document)"
                  class="uk-button-small uk-margin-right uk-button-default uk-border-rounded uk-text-bold"
                >Voir le détail</button>
                <button
                  v-on:click="pay(document)" 
                  v-show="shouldShowPayButton(document)"
                  class="uk-button-small uk-button-primary uk-margin-remove-right uk-border-rounded uk-text-bold"
                >Payer</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      </div>
      <div class="uk-flex-center uk-width-auto uk-position-center" v-show="documents.length == 0">
        <img height="350" width="200" src="../assets/no-documents.png" />
        <p class="uk-text-large uk-text-uppercase uk-text-bold">Aucun document disponible.</p>
      </div>
    </div>
</template>

<script>
import Invoice from "../models/invoice";
import Quotation from "../models/quotation";
import firebase from "firebase";
import router from "../router";
import Header from "../components/Header";

export default {
  name: "quotation",
  components: {
    Header
  },
  data() {
    return {
      documents: [],
      isLoading: false,
      searchText: ""
    };
  },

  mounted() {
    const self = this;
    self.isLoading = true;
    firebase
      .firestore()
      .collection("Invoices")
      .orderBy("createdAt", "desc")
      .where("ownerUID", "==", firebase.auth().currentUser.uid)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.documents.push(new Invoice(doc));
        });

        ///
        firebase
          .firestore()
          .collection("Quotations")
          .orderBy("createdAt", "desc")
          .where("ownerUID", "==", firebase.auth().currentUser.uid)
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              var quotation = new Quotation(doc)
              if (quotation.status === undefined || quotation.status !== "invoiced") {
                this.documents.push(quotation);
              }
            });
            self.isLoading = false;
          })
          .catch(function(error) {
            console.log("Error getting documents: ", error);
          });
        ///
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  },

  methods: {
    search: function() {
    },

    consult: function(document) {
      const storage = firebase.storage().ref();
      var path = document.firebaseStoragePath();

      storage
        .child(path)
        .getDownloadURL()
        .then(function(url) {
          window.open(url, "_blank", "fullscreen=yes");
        })
        .catch(function(error) {
          console.log(error)
          // Handle any errors
        });
    },

    async getDoc(index) {
      return new Promise((resolve, reject) => {
        var storage = firebase.storage().ref();
        storage
          .child("quotations/" + this.getTitle(index) + ".pdf")
          .getDownloadURL()
          .then(function(url) {
            resolve(url);
          })
          .catch(function(error) {
            console.log(error);
            reject(error)
          });
      });
    },

    async open(index) {
      const url = await this.getDoc(index);
      window.open(url, "_blank", "fullscreen=yes");
    },

    async download(index) {
      const url = await this.getDoc(index);
      window.open(url, "_blank", "fullscreen=yes");
    },

    pay: function(document) {
      router.push({ path: `/check-quotation/${document.quotationID}` });
    },

    getTitle(document) {
      var title =
        document instanceof Invoice
          ? "Facture-" + document.invoiceID
          : "Devis-" + document.quotationID;
      return title;
    },

    getReadableType(document) {
      var type = document instanceof Invoice ? "Facture" : "Devis";
      return type;
    },

    getReadableStatus(document) {
      return document.status === 'invoiced' ? 'Payé' : 'Non payé';
    },

    shouldShowPayButton: function(document) {
      return !(document instanceof Invoice);
    },

    toNumericReadableFormat: function(date) {
      var day = date.getDate();
      var monthIndex = date.getMonth() + 1;
      var year = date.getFullYear();
      return "" + day + "/" + monthIndex + "/" + year;
    }
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}

p {
  color: black;
}

.uk-button-primary:hover {
  background-color: #234b70;
  cursor: pointer;
}

.uk-button-default:hover {
  cursor: pointer;
}

table tr:hover {
  background-color: rgba(48, 158, 181, 0.05);
}
</style>